export default "__VITE_ASSET__C9qS7Jb0__"